import React from 'react';

interface ProjectInfoProps {
    sidebarOpen: boolean;
    activeProject?: string;
    activeStandard?: string;
}

export const ProjectInfo: React.FC<ProjectInfoProps> = ({ sidebarOpen, activeProject, activeStandard }) => {
    if (!sidebarOpen || !activeProject) return null;

    return (
        <div className="p-4 border-b border-[var(--border-color)]">
            <div className="w-full flex items-center justify-between p-3 rounded-lg bg-[var(--bg-tertiary)] transition-colors">
                <div className="text-left">
                    <p className="text-xs text-[var(--text-secondary)]">Active Project</p>
                    <p className="text-sm font-medium text-[var(--text-primary)]">
                        {activeProject}
                    </p>
                </div>
            </div>
            {activeStandard && (
                <div className="mt-2 flex justify-center">
                    <span className="px-2 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 dark:bg-primary-900 dark:text-primary-300">
                        {activeStandard.replace('_', ' ')}
                    </span>
                </div>
            )}
        </div>
    );
};
